import { Theme } from '@mui/material';

export const APP_BAR_HEIGHT = 73;
export const NAV_BAR_LIST_ITEM_HEIGHT = 48;
/** New design has no extra strip to the right of the sidebar (it used to hold the white active-item pointer). */
export const NAV_BAR_DRAWER_RIGHT_SPACE = 0;
export const NAV_BAR_DRAWER_RIGHT_SPACE_COLLAPSED = 0;
export const NAV_DRAWER_WIDTH = 240;
export const NAV_DRAWER_WIDTH_COLLAPSED = 64;

export function getNavDrawerCollapsedWidth(_theme?: Theme, _breakpoint?: 'sm' | 'md') {
	return `${NAV_DRAWER_WIDTH_COLLAPSED}px`;
}
